/*
 * @Author: LiuLiXue QQ:136890965
 * @Date: 2017-10-17 16:36:07
 * @Last Modified by: jsZhao
 * @Last Modified time: 2017-12-27 16:30:18
 */
/**本文件定义了公共函数**/
import Cookie from 'js-cookie';
import Vue from 'vue'

// 读取本地存取的cookie,name为本地保存的cookie的key eg：读取保存的email getCookie('email')
export function getCookie(name) {
  return Cookie.get(name)
}

export function setCookie(name,value) {
  return Cookie.set(name,value);
}

export function clearCookies () {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if(keys) {
    for(var i = keys.length; i--;)
      document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
  }
}
Date.prototype.format = function(format) {

      var date = {
          "M+": this.getMonth() + 1,
          "d+": this.getDate(),
          "h+": this.getHours(),
          "m+": this.getMinutes(),
          "s+": this.getSeconds(),
          "q+": Math.floor((this.getMonth() + 3) / 3),
          "S+": this.getMilliseconds()
      };
      if (/(y+)/i.test(format)) {
          format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      for (var k in date) {
          if (new RegExp("(" + k + ")").test(format)) {
              format = format.replace(RegExp.$1, RegExp.$1.length == 1
                  ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
          }
      }
      return format;
  }
Vue.prototype.uwsToDate = stamp => {
  return new Date(stamp).format('yyyy/MM/dd hh:mm:ss');
}

/**
 * 这个是专门用在tab表格里的方法
 * @param row
 * @param column
 * @returns {string}
 */
Vue.prototype.toFixed = (row, column) => {
  let number = String(row[column.property])
  let r = number.indexOf('.')
  if (-1 === r) {
    return `${number}.00`
  }
  else {
    let float = number.split('.')[1].length
    if (0 === float) {
      return `${number}00`
    }
    else if (1 === float) {
      return `${number}0`
    }
    else {
      return `${number}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/common.js